import styled from "styled-components";
import { MOBILE_WIDTH } from "datastake-daf/src/constants/Style";

export const Styles = styled.div`
  background: white;
  height: 100%;
  display: flex;
  flex-direction: column;
  
  .ant-table-container table > thead > tr:first-child th:first-child {
    border-top-left-radius: 8px;
  }
  .ant-table-container table > thead > tr:first-child th:last-child {
    border-top-right-radius: 8px;
  }

  .default-pagination {
    border-top: 0px !important;
  }
  
  .ant-space {
    width: 100%;
    .ant-space-item {
      width: 100%;
    }
  }
  
  .ant-input-affix-wrapper-disabled  {
    background-color: transparent;
    cursor: pointer;
    color: rgba(0, 0, 0, 0.65);
    input {
      background-color: transparent;
      cursor: text;
      color: rgba(0, 0, 0, 0.65);
    }
  }
  .columns {
    span[role="img"] {
      margin-left: 8px
    }
  }
  .projectLink {
    color: rgba(0, 0, 0, 0.7);
    font-weight: 500;
    text-decoration: underline;
  }
  .ant-drawer-body {
    padding: 0;
  }

  .app-content {
    flex: 1;
    overflow: auto;
    background: white;
    margin: 0 var(--size-lg) var(--size-lg) var(--size-lg);
    padding: var(--size-lg);
    border-radius: 8px;
    overflow-y: auto;
    border: 1px solid #E5E7EB;

    @media(${MOBILE_WIDTH}) {
      border: 0px;      
      padding: 0px;
      margin: 0px;
      height: calc(100% - 154px);

      .table-filters {
        margin: 0px var(--size-lg);
      }
    }
  }

  &.no-tabs {
    .app-content {
      height: calc(100% - 114px - var(--size-lg));
    }
  }
`